import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { RemoveBrickFromInnerWallBrick } from '../brick-settings/specific-brick-settings/inner-wall-brick-settings/inner-wall-brick-settings.actions';
import { InnerWallBrickSettingsState } from '../brick-settings/specific-brick-settings/inner-wall-brick-settings/inner-wall-brick-settings.state';
import { RemoveTabForTabBrick } from '../brick-settings/specific-brick-settings/tab-brick-settings/tab-brick-settings.actions';
import { TabBrickSettingsState } from '../brick-settings/specific-brick-settings/tab-brick-settings/tab-brick-settings.state';
import { RemoveBrickFromWall } from './brick-instances.actions';

// tslint:disable-next-line: no-empty-interface
export interface BrickInstancesHelperModel {}
@State<BrickInstancesHelperModel>({
   name: 'brickInstancesHelper',
})
@Injectable()
export class BrickInstancesHelper {
   private static removeSubBricks(store: Store, brickInstanceIdToRemove: string) {
      store
         .selectSnapshot(TabBrickSettingsState.getTabs)(brickInstanceIdToRemove)
         .forEach((tab) => store.dispatch(new RemoveTabForTabBrick(brickInstanceIdToRemove, tab.tabId, tab.brickInstanceId)));
      store
         .selectSnapshot(InnerWallBrickSettingsState.brickInstanceIdsForInnerWallBrickFn)(brickInstanceIdToRemove)
         .forEach((brickInstanceId) => store.dispatch(new RemoveBrickFromInnerWallBrick(brickInstanceIdToRemove, brickInstanceId)));
   }

   constructor(private store: Store) {}
   @Action(RemoveBrickFromInnerWallBrick)
   @ImmutableContext()
   public removeBrickFromInnerWallBrick(ctx: StateContext<BrickInstancesHelperModel>, action: RemoveBrickFromInnerWallBrick) {
      BrickInstancesHelper.removeSubBricks(this.store, action.brickInstanceIdToRemove);
   }

   @Action(RemoveTabForTabBrick)
   @ImmutableContext()
   public removeTabForTabBrick(ctx: StateContext<BrickInstancesHelperModel>, action: RemoveTabForTabBrick) {
      BrickInstancesHelper.removeSubBricks(this.store, action.brickInstanceIdToRemove);
   }

   @Action(RemoveBrickFromWall)
   @ImmutableContext()
   public removeBrickFromWall(ctx: StateContext<BrickInstancesHelperModel>, action: RemoveBrickFromWall) {
      BrickInstancesHelper.removeSubBricks(this.store, action.brickInstanceId);
   }
}
